import React, { useState } from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { AppConfiguration } from "src/common";
import { SearchForm, SearchFilters } from "..";
type AllProps = {
  mailbox_name: string;
  full_search: boolean;
  handleAction: ActionHandlerFunction;
}

// NOTE: Search will only be available for App build mode for now
const enable_search = AppConfiguration.buildForApp();

function MailSearchHeaderComponent(props: AllProps) {
  const { mailbox_name, full_search, handleAction } = props;
  const [search_mode, setSearchMode] = useState<boolean>(false);  // Description: Toggle search form and header in mobile view

  return <>
    <div className={`header-flex${search_mode ? " searching" : ""}`}>
      <h1>{mailbox_name}</h1>
      {
        enable_search &&
        <SearchForm
          searchMode={search_mode}
          handleSearchModeAction={(search_mode: boolean) => setSearchMode(search_mode)}
          handleAction={handleAction} />
      }
    </div>
    {
      (enable_search && full_search) && <SearchFilters />
    }
  </>;
}

export default React.memo(MailSearchHeaderComponent);